/**
 * Name of the token saved in local storage.
 */
export const tokenStorageName: string = 'x-sd-authorzation-token';

/**
 * Name of the sidebar state saved in local storage.
 */
export const dashboardSidebarStorageName: string = 'x-sd-sidebar-state';

/**
 * Name of the help sidebar state saved in local storage.
 */
export const helpSidebarStorageName: string = 'x-sd-help-sidebar-state';

/**
 * Prefix of the dropdown census filter.
 */
export const censusSettingsViewPrefix: string = 'fvs-';

/**
 * Prefix of the dropdown toplist filter.
 */
export const toplistSettingsViewPrefix: string = 'tfvs-';

/**
 * Prefix of the census filter's value.
 */
export const censusSavedSettingsValuePrefix: string = 'sfv-';

/**
 * Prefix of the census vorabtv value.
 */
export const censusSavedVorabValuePrefix: string = 'svtvv-';

/**
 * Prefix of the toplist filter's value.
 */
export const toplistSavedSettingsValuePrefix: string = 'tsfv-';

/**
 * License key of the handsontable.
 */
export const hotTableLicenseKey = '6f3bc-e090a-885c4-d4748-88239';

/**
 * Prefix of the census table column's width.
 */
export const censusTableColumnWidthPrefix = 'cW-';

/**
 * Prefix of the census table column's width.
 */
export const censusSmartTableColumnWidthPrefix = 'cSW-';

/**
 * Prefix of the sort field for census table.
 */
export const censusSortFieldPrefix = 'soF-';

/**
 * Prefix for currently opened cart id.
 */
export const censusCartIdPrefix = 'cocid-';

export const smartViewFactTypeTotal = 'svfttotal';
export const smartViewFactTypeOrfOn = 'svftorfon';
export const smartViewFactTypeVorabTv = 'svftvorabtv';
